module.exports = "/img/partnership-2.4b1a399a.png";